import { Banner } from "@components/ui-kit";
import { t } from "@lingui/macro";
import type { ComponentProps, ReactNode } from "react";

interface ModelLockBannerProps
  extends Omit<
    ComponentProps<typeof Banner>,
    "title" | "status" | "primaryAction" | "description"
  > {
  show: boolean;
  loading: boolean;
  onClick: () => void;
  /** Defines if a user can unlock the model */
  canUnlock: boolean;
  /** The model this banner is for (e.g. "expense") */
  model: string;
  /** Translations to override the default ones */
  translations?: {
    title?: ReactNode;
    description?: ReactNode;
    descriptionWithPermission?: ReactNode;
  };
}

export function ModelLockBanner({
  show,
  model,
  translations,
  canUnlock,
  loading,
  onClick,
  ...props
}: ModelLockBannerProps) {
  if (!show) {
    return null;
  }

  return (
    <Banner
      {...props}
      title={translations?.title ?? t`This ${model} is locked`}
      status="warning"
      primaryAction={{
        title: t`Unlock`,
        loading,
        onClick,
      }}
      description={
        canUnlock
          ? (translations?.descriptionWithPermission ??
            t`You must unlock it to edit.`)
          : (translations?.description ??
            t`You do not have the permission to unlock it.
            Please contact Admin or CFO to allow editing.`)
      }
    />
  );
}
